import { authStore } from '@/store/authStore'

export interface SentryContext {
  userId: string | null
}

/**
 * Extract context for Sentry from the auth store
 * This is simpler than qsk-web since we don't have courses or language
 */
export const getContextForSentry = (): SentryContext => {
  const context: SentryContext = {
    userId: null,
  }

  // Get user ID from auth store
  const state = authStore.state
  if (state.user?.id) {
    context.userId = state.user.id
  }

  return context
}
